import SegmentedControl from "@plannel/components/ui/SegmentedControl";
import { FONT } from "@plannel/components/ai/typographyTokens";

// AI 카드 본문(FONT.CAPTION)에 맞춘 축소 세그먼트 — 공용 프리미티브는 건드리지 않고 sx 로만 조인다.
//   `&&` 로 기본 규칙보다 우선순위를 올린다(같은 키를 넘기면 얕은 병합으로 기본 스타일이 통째로 날아감).
const BASE_SX = {
  p: "2px",
  "&& .MuiToggleButtonGroup-grouped": { fontSize: FONT.CAPTION, px: 1.1, py: "2px" },
};

// accent — 카드마다 색이 다른 시나리오 카드에서만 선택색을 그 카드 색에 맞춘다(미지정 시 앱 primary).
const accentSx = (accent) => ({
  "&& .MuiToggleButtonGroup-grouped.Mui-selected": {
    bgcolor: accent, color: "#fff",
    "&:hover": { bgcolor: accent, filter: "brightness(0.92)" },
  },
});

const AiSegmentedControl = ({ accent, sx, ...rest }) => (
  <SegmentedControl {...rest} sx={{ ...BASE_SX, ...(accent ? accentSx(accent) : null), ...sx }} />
);

export default AiSegmentedControl;
